import {Component, inject, OnDestroy} from '@angular/core';
import {Accordion, AccordionContent, AccordionHeader, AccordionPanel} from 'primeng/accordion';
import {ProjectStepStateService} from '../project-step-state.service';
import {ProjectStepDescriptionTranslation} from '@frontend/directus';
import {SafeHtmlComponent} from '../../../../shared/components/safe-html-output/safe-html-output.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {Subject} from 'rxjs';
import {BaseDialogComponent} from '../../../../shared/components/dialog/base-dialog/base-dialog.component';

@Component({
  selector: 'app-chapter-description-dialog',
  templateUrl: './chapter-description-dialog.component.html',
  imports: [
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    SafeHtmlComponent,
    TranslocoPipe,
    BaseDialogComponent,
  ],
})
export class ChapterDescriptionDialogComponent implements OnDestroy {
  private readonly stepState = inject(ProjectStepStateService);
  private readonly transloco = inject(TranslocoService);

  visible = this.stepState.descriptionDialogVisible;
  stepDescription = this.stepState.currentStepDescription;
  title = this.stepState.getCurrentStepDescriptionTitle;
  readonly activeLanguage = this.transloco.getActiveLang();
  private readonly destroy$ = new Subject<void>();

  currentTranslation(): ProjectStepDescriptionTranslation | undefined {
    return this.stepDescription()?.translations.find((tr) => tr.language === this.activeLanguage);
  }

  close(): void {
    this.stepState.closeStepDescription();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
